import * as S from '../components/Static.styles'

const defaultProps = {}
const propTypes = {}

export const PrivacyPolicy = () => {
  return (
    <S.Article id="post-3">
      <S.Header>
        <S.Title>Privacy Policy</S.Title>
      </S.Header>
      <S.Content>
        <p>TrialSite values your privacy.</p>
        <p>
          This Privacy Statement of TrialSite, Inc (“TrialSite News” “we” “us”
          or “our”) outlines how your personally identifiable information and
          other personal data (your “user information”) will be collected, used,
          and shared in connection with your access to and/or use of
          trialsitenews.com and any content, features, services, or other
          offerings that TrialSite News may provide in connection therewith
          (collectively, the “Site”). This Privacy Statement also describes your
          choices and rights regarding the use, access and correction or
          deletion of your user information. By using the Site, you consent to
          the use of your user information in accordance with this Privacy
          Statement. If you are located in the EU, you will also be asked to
          provide clear and unequivocal affirmative consent to the collection,
          processing, and sharing of your user information via cookies and
          similar technologies. The Site is owned and operated by TrialSite,
          Inc.
        </p>
        <p>
          Notice to EU Individuals: this Privacy Statement and its enumerated
          policies are intended to comply with Regulation (EU) 2016/679 of the
          European Parliament and of the Council of 27 April 2016 (the “General
          Data Protection Regulation” or “GDPR”) and provide appropriate
          protection and care with respect to the treatment of your user
          information in accordance with the GDPR.
        </p>
        <p>Summary</p>
        <p>
          To enhance, personalize, and support your experience on the Site,
          among other things, we collect, use, and share your user information.
          For example, we use aggregated information to develop content targeted
          to user interests and to generally improve the Site’s user experience.
          As detailed below, your user information may also be used by TrialSite
          News and its partners to tailor content and ads, provide social media
          features (e.g., features that allow you to share content directly to
          your preferred social media platform), track your preferences, analyze
          traffic, and provide similar services and content. TrialSite News is
          committed to your privacy and will not share any user information with
          any third party without your consent, except as outlined in this
          Privacy Statement or as permitted by law. If you have any requests,
          comments, or questions about this Privacy Statement or your user
          information, please contact us in the manner provided below.
        </p>
        <p>What this Privacy Statement Covers</p>
        <p>
          This Privacy Statement covers the Site. While you may encounter links
          on the Site to other websites, such as those relating to our third
          party sponsors, advertisers, and other partners, please note that
          these websites are not covered by this Privacy Statement (unless
          otherwise noted on such site, which may be the case if, for example,
          the site is also owned and operated by TrialSite).
        </p>
        <p>
          This Privacy Statement does not apply to the activities of TrialSite
          third party sponsors, advertisers, and other partners that may collect
          your user information while accessing or using such third party’s
          services in connection with your use of our Site (e.g. social media
          and sharing services). The privacy and information practices of those
          third parties are not covered by this Privacy Statement. To learn more
          about such third party policies, we encourage you to read and review
          the privacy statements of each third party service that you may choose
          to use in connection with the Site. This Privacy Statement applies
          only to information collected by us.
        </p>
        <p>
          As a general reminder, please think carefully before you decide to put
          anything on the internet. For example, if you voluntarily disclose
          user information in chat areas or bulletin boards (e.g., comments
          sections), that information could be seen and used by others, and may
          result in unsolicited messages from others. We are not responsible for
          the personally identifiable information or other user information you
          may choose to submit in these public forums. To request removal of
          your personal information from our blog or community forum, please
          contact us as provided below. In some cases, we may not be able to
          remove personal information voluntarily disclosed by you in such
          forums for legal retention purposes or technical limitations (e.g.,
          the data may not be searchable), in which case, we will notify you if
          we are unable to do so.
        </p>
        <p>Gathering of Information</p>
        <p>
          Section Overview: We collect user information when you use the Site.
          Sometimes you may submit it to us yourself, other times it may be
          collected automatically. You can manage and change your preferences as
          outlined below.
        </p>
        <p>Information Collected</p>
        <p>
          When you use the Site, your user information may be collected, used,
          and shared in a variety of manners. As detailed below, the type of
          user information collected may vary based on how it was gathered, but
          may include, among other things, your name, email address, and other
          information that you voluntarily submit (e.g., when setting up an
          account or submitting a registration or application on the Site, you
          may submit your contact information, social media account handles,
          and/or professional information), information automatically collected
          about your usage of the Site (e.g., the content that you choose to
          view), and information about you that our third party partners may
          share with us if such third party partners have previously received
          your consent to do so.
        </p>
        <p>Voluntary Submission</p>
        <p>
          TrialSite may collect user information that is voluntarily provided by
          you or with your permission. For example, we may ask you for
          information, such as your e-mail address, when you register to become
          a member of the Site or register for a TrialSite produced live event.
          You may also provide information to TrialSite News in other contexts,
          including, for example, on your member profile page and public profile
          URL, to enter into a sweepstakes, contest, or promotion, or to apply
          for consideration in connection with a TrialSite list or similar
          accolade (e.g., Under 30 list applications). In the event you order
          something from the Site or one of our co-branded websites, we may
          request additional personal information, such as your address,
          telephone number and credit card information, in order to complete the
          purchase. You always have the option not to provide the information we
          request. If you choose not to provide the information we request, you
          can still visit most of the Site, but you may be unable to access
          certain options and services. When you register or become a member of
          the Site or provide information to TrialSite in any other manner, you
          agree to provide only true, accurate, current and complete
          information. We also supplement the data you provide to us with data
          from data append services such as public or social graph data in order
          to better serve you with content or promotions.
        </p>
        <p>Cookies</p>
        <p>
          A cookie is a small data file that is written to your computer’s hard
          drive by your web browser. A cookie file can contain and/or
          automatically collect information, such as a user identification code
          or IP address, that a website will use to track the pages and number
          of times you have visited. The data read from these cookies may be
          linked to personally identifying (PII) and non-personally identifying
          (non-PII) information.
        </p>
        <p>
          We and our partners use cookies and similar technologies on the Site
          to personalize and optimize your browsing experience and the Site by:
        </p>
        <p>
          providing you tailored content and advertisements (see below for more
          information),
          <br /> enabling social media features,
          <br /> safeguarding against spam and malware,
          <br /> analyzing trends, traffic, and user behavior,
          <br /> administering the website,
          <br /> gathering demographic information about our user base as a
          whole,
          <br /> tracking web and advertising analytics throughout the Site and
          its affiliate websites,
          <br /> remembering your preferences and voluntarily-submitted
          information (e.g. custom video playlists, preferences, job title,
          story ratings, membership status),
          <br /> performing location-related functionalities and analytics,
          <br /> participating in market research (e.g., website ratings), and
          <br /> educating ourselves about how we can continue to improve the
          Site and its various elements.
          <br /> Cookies fall into the subcategories below.
        </p>
        <p>
          Essential Cookies. Certain cookies are used for specific purposes that
          are essential to your secure use and navigation of the Site. Without
          them, TrialSite News may not be able to provide core Site functions
          and features to you, and the Site would not operate as well as you or
          TrialSite News would like. These cookies collect and use information
          such as your server preferences, single-session data and corresponding
          identifier, web beacons and log files (detailed below), and other
          credential-related information. For EU individuals, essential cookies
          also help inform TrialSite News whether you require, or have already
          been served, an affirmative consent request in connection with the
          GDPR. Essential cookies include analytics cookies, which provide us
          data that allows TrialSite News to better understand its users and
          improve the Site based on what we have learned from that data.
        </p>
        <p>
          Preference Cookies. Other cookies are used to collect and process
          information about your preferences and similar choices in connection
          with the Site in order to optimize your browsing experience.
          Preference cookies include social media cookies, which collect
          information about your social media usage and other data you may have
          provided in connection with such usage (if you access the Site through
          a social media website or mobile application, you may have social
          media cookies). If you wish to modify or change your social media
          cookies, please visit and review the settings on your applicable
          social media account(s).
        </p>
        <p>
          Advertising Cookies. To help support the Site and further tailor your
          experience, TrialSite News and its advertising partners (and/or their
          third party analytics providers) also use cookies on the Site to
          personalize the content and advertisements you may be shown. Such
          advertisements use cookies to provide you targeted advertisements that
          may be more consistent with your interests than non-targeted
          advertisements. Certain TrialSite News advertising partners may also
          use cookies to monitor or track the performance of their advertising
          content, including native advertising content (e.g., BrandVoice).
          TrialSite News does not provide user information to advertising
          partners except in connection with the Site or as required by law.
        </p>
        <p>
          We encourage you to consider keeping your cookies enabled, as if you
          choose to disable the receipt of cookies from our Site, you may not be
          able to use or benefit from certain features of the Site, particularly
          the features that are designed to personalize your experience. To
          learn more about the use of cookies in online advertising including
          how to manage or delete them click here.
        </p>
        <p>
          Most web browsers automatically accept cookies, but generally allow
          users to modify their browser settings to display a warning before
          accepting a cookie, to accept cookies only from certain websites,
          and/or to refuse all cookies.
        </p>
        <p>Web Beacons</p>
        <p>
          We use web beacons (invisible images often referred to as pixel tags
          or clear GIFs) on our sites in order to recognize users, assess
          traffic patterns, identify preferred content and measure site
          engagement. We also include web beacons in our e-mail messages,
          including newsletters, in order to count how many e-mail messages have
          been opened.
        </p>
        <p>
          TrialSite News and its partners (including advertising partners) also
          use web beacons to collect various data provided by your browser while
          you are on our Site and elsewhere (i.e., outside of the Site) where we
          may be acting as a 3rd party. This data is collected in the aggregate,
          but may include or be associated with other non-PII or PII that users
          have voluntarily submitted.
        </p>
        <p>Log Files</p>
        <p>
          The Site’s web and ad servers log information about a user’s IP
          address, browser type and the current URL the user is requesting. This
          information is always provided by a user’s browser and automatically
          logged by most websites. These log files are stored in a secure
          location and used in our internal analysis of traffic patterns within
          our website.
        </p>
        <p>Use of Your Information</p>
        <p>
          Section Overview: Our primary goal in collecting, using, and sharing
          user information is to enhance your experience on the Site, support
          the Site, and improve its features, performance, and other elements.
          Your user information may be used for the purposes outlined below. We
          will not use your user information without a valid legal basis to do
          so.
        </p>
        <p>To Target Content and Advertising</p>
        <p>
          To develop and provide content and advertising to you that is targeted
          to your interests, we use the analytics collected by the systems
          described above to determine which areas of our website you prefer
          based upon the frequency of your visits and engagement with those
          areas. We may make reasonable assumptions based on your browser
          provided data to target relevant content and advertising to you on our
          site and elsewhere where we may be acting as a 3rd party. We may also
          make reasonable geographic and demographic assumptions based on your
          presented IP address to target relevant content and advertising.
        </p>
        <p>To Provide Interactive Communications from the Site</p>
        <p>
          To enhance your experience we may provide you with interactive
          communications, such as notifications of activity by topic or
          contributor to the e-mail address that you provide to us. Such
          interactive communications are provided only to those users who have
          expressly provided us with their permission to receive them as part of
          their user profile.
        </p>
        <p>
          From time to time we may provide e-mails highlighting new features,
          promotions or contests on the website to those users who have
          expressly provided us with their permission to send such
          communications as part of their user profile.
        </p>
        <p>Sharing of Information</p>
        <p>
          You may be requested to voluntarily provide certain user information
          during your use of the Site. If you choose to do so, that user
          information may be shared with TrialSite News as well as business
          partners and vendors providing hosting and other services for
          TrialSite News.
        </p>
        <p>
          We use third parties to provide credit card processing, e-mail service
          providers and hosting services on the Site. When you sign up for such
          services, we will share your user information only as necessary for
          the third party to provide that service. These third parties are
          prohibited from using your user information for any other purpose.
          With respect to credit card processing, we do not collect, store, or
          process any credit card information.
        </p>
        <p>
          In addition, if you provide any personally identifiable information
          via an advertiser promotion, please be aware you are directly
          providing your personally identifiable information to that advertiser.
        </p>
        <p>
          From time-to-time we may provide you the opportunity to participate in
          contests or surveys on our site. If you participate, we will request
          certain personally identifiable information from you, such as your
          name and e-mail. Participation in these surveys or contests is
          completely voluntary and you therefore have a choice whether or not to
          disclose this information. We use this personally identifiable
          information to notify contest winners and award prizes.
        </p>
        <p>
          We may use a third party service provider to conduct these surveys or
          contests; that company will be prohibited from using our users’
          personally identifiable information for any other purpose. We will not
          share the personally identifiable information you provide through a
          contest or survey with other third parties unless we give you prior
          notice and choice.
        </p>
        <p>
          As noted above, you can log in to our site using sign-in services that
          bridge your social media login information with the Site. These
          services will authenticate your identity and provide you the option to
          share certain personal information with us such as your name and email
          address to pre-populate our sign up form. These services give you the
          option to post information about your activities on this website to
          your profile page to share with others within your network. The Site
          includes social media features, widgets and/or interactive
          mini-programs that run on our site. These features are small content
          modules that users can embed on sites and may collect your IP address,
          which page you are visiting on our site, or set a cookie to enable the
          feature to function properly. Social media features and widgets are
          either hosted by a third party or hosted directly on our website. Your
          interactions with these features are governed by the privacy policy of
          the company providing it.
        </p>
        <p>
          We offer widgets that are hosted on the Site, like our embeddable
          video player. Use of the TrialSite News.com widgets is subject to the
          Site terms of use, but downloading or embedding these widgets on other
          websites is not covered by this privacy statement.
        </p>
        <p>As Necessary to Provide Services to You</p>
        <p>
          We occasionally hire other companies to provide limited services on
          our behalf, such as handling the processing and delivery of newsletter
          mailings, processing transactions, or performing statistical analysis
          of our services. We will only provide those companies the information
          they need to deliver the service. In some instances, these companies
          may collect information directly from you. In these cases, you will be
          notified of the involvement of the external service provider. In all
          cases, these companies are subject to agreements that require them to
          maintain the confidentiality of your information and they are
          prohibited from using that information for any other purpose.
        </p>
        <p>In the Event of Sale or Bankruptcy</p>
        <p>
          The ownership of the Site may change at some point in the future.
          Should that occur, we want this site to be able to maintain a
          relationship with you. In the event of a sale, merger, public
          offering, bankruptcy or other change in control of TrialSite News,
          your information may be shared with the person or business that owns
          or controls this site. Opting out of receiving information from third
          parties will not affect our right to transfer your information to a
          new owner, but your choices will continue to be respected regarding
          the use of your information. You will be notified as described below
          in “How will I know if the Privacy Statement is changed.”
        </p>
        <p>As Required By Law</p>
        <p>
          TrialSite may disclose your personal information if required to do so
          by law such as to comply with a subpoena or in the good faith belief
          that such action is necessary to conform to the edicts of the law,
          protect your safety or the safety of others, investigate fraud or
          comply with a judicial proceeding, court order or legal process served
          on TrialSite News or to protect and defend the rights or property of
          TrialSite News.
        </p>
        <p>
          Notice to EU Individuals: As outlined in this Privacy Statement,
          TrialSite News will not process your user information without a lawful
          basis to do so, as such bases are defined in Article 6 of the GDPR. In
          general, TrialSite News will process your user information on the
          legal bases of consent, contract (if you have entered into an
          agreement with us and such processing is a necessary part thereof), or
          legal obligation (as noted above). TrialSite News may also process
          certain user information on the basis of the following legitimate
          interests, provided that such interests are not overridden by your
          privacy rights and interests: delivering and continuing to develop and
          improve the Site, learning from your behavior on the Site (e.g.,
          analyzing traffic) to better serve you and other Site users, helping
          us modify or enhance the Site and its content, receiving insight as to
          what users do (and don’t) like about our Site or aspects thereof, and
          providing a stable, consistent, and secure user experience in
          connection with the Site.
        </p>
        <p>Security</p>
        <p>
          Section Overview: We care about the protection of your user
          information and use industry standard safeguards to do so. Of course,
          it’s important to keep in mind that no data transmission on the
          Internet is guaranteed to be 100% secure.
        </p>
        <p>
          Your information is stored on TrialSite servers located in the United
          States. We use industry standard physical, electronic, and
          organizational safeguards to protect your user information against
          loss or theft as well as unauthorized access and disclosure to protect
          your privacy. We treat data as an asset that must be protected against
          loss and unauthorized access. We employ many different security
          techniques to protect such data from unauthorized access by users
          inside and outside the company. However, “perfect security” does not
          exist on the Internet. If you are concerned that your privacy may have
          been breached, please contact us as provided below.
        </p>
        <p>Privacy of Children</p>
        <p>
          Section Overview: The Site is intended for people who are at least 16
          years of age.
        </p>
        <p>
          If you are less than 16 years old, please do not send any user
          information to us–including information such as your name, address, or
          e-mail address. We do not knowingly collect (nor do we wish to
          collect) any personally identifiable information or other user
          information from children under the age of 16. In the event that we
          learn we have collected any personal information from a child under
          the age of 16, we will delete that information from our database and
          terminate the corresponding account, if any. We encourage you to
          discuss the Site with your parent or guardian.
        </p>
        <p>Cross-border Transfers</p>
        <p>
          Section Overview: Your user information may be transferred to other
          countries in connection with your use of the Site. If you access or
          use the Site outside of the United States, your user information will
          be transferred to our servers in the United States.
        </p>
        <p>
          TrialSite participates in and has certified its compliance with the
          EU-U.S. Privacy Shield Framework and the Swiss-U.S. Privacy Shield
          Framework. TrialSite News is committed to subjecting all personal data
          received from European Union (EU) member countries and Switzerland,
          respectively, in reliance on each Privacy Shield Framework, to the
          Framework’s applicable Principles. To learn more about the Privacy
          Shield Framework, visit the U.S. Department of Commerce’s Privacy
          Shield List at https://www.privacyshield.gov/list. TrialSite News is
          responsible for the processing of personal data it receives, under
          each Privacy Shield Framework, and subsequently transfers to a third
          party acting as an agent on its behalf. TrialSite News complies with
          the Privacy Shield Principles for all onward transfers of personal
          data from the EU and Switzerland, including the onward transfer
          liability provisions With respect to personal data received or
          transferred pursuant to the Privacy Shield Frameworks, TrialSite News
          is subject to the regulatory enforcement powers of the U.S. Federal
          Trade Commission. In certain situations, TrialSite News may be
          required to disclose personal data in response to lawful requests by
          public authorities, including to meet national security or law
          enforcement requirements. If you have an unresolved privacy or data
          use concern that we have not addressed satisfactorily, please contact
          our U.S.-based third party dispute resolution provider (free of
          charge) at https://feedback-form.truste.com/watchdog/request Under
          certain conditions, more fully described on the Privacy Shield website
          at https://www.privacyshield.gov/article?id=How-to-Submit-a-Complaint,
          you may invoke binding arbitration when other dispute resolution
          procedures have been exhausted.
        </p>
        <p>How to Contact Us</p>
        <p>Please contact us if you have any questions or requests.</p>
        <p>
          If you have any questions regarding this Privacy Statement or how to
          remove or modify your user information or related consents, please
          feel free to contact us by e-mail at info@trialsitenews.com or the
          mailing address below. Our mailing address is:
        </p>
        <p>
          TrialSite, Inc
          <br /> 159 W Broadway, Suite 200
          <br /> Salt Lake City, UT 84101
        </p>
        <p>
          <S.MailTo href="mailto:info@trialsitenews.com">
            <strong>info@trialsitenews.com</strong>
          </S.MailTo>
        </p>
        <p>How Will I Know if the Privacy Statement Is Changed?</p>
        <p>
          If we make any material changes we will notify you by email (sent to
          the e-mail address specified in your account) or by means of a notice
          on this website prior to the change becoming effective. We encourage
          you to periodically review this page for the latest information on our
          privacy practices.
        </p>
        <p>
          Note on Translated Version(s): For your convenience, TrialSite News
          may make translated versions of this Privacy Statement available on
          the Site. In the event that the terms of any such translated version
          conflict with the terms of the English version, the terms of the
          English version of this Privacy Statement will control in all
          instances.
        </p>
      </S.Content>
    </S.Article>
  )
}

PrivacyPolicy.defaultProps = defaultProps
PrivacyPolicy.propTypes = propTypes

export default PrivacyPolicy
